import type { TabsProps } from "antd";

import { ActionBar } from "../../components/ActionBar/ActionBar";
import { FPage, FPageContent, FPageHeader, FPageTitle } from "../../components/AppLayout/components/FPageLayout";
import { FormTab, FormTabActiveHtml, FormTabHtml } from "../../components/Form/layouts/styles/LayoutComponent";

const items: TabsProps["items"] = [
    {
        key: "1",
        label: "AntD Tab 1",
    },
    {
        key: "2",
        label: "AntD Tab 2",
    },
    {
        key: "3",
        label: "AntD Tab 3",
    },
];
export const FormPageDocs = () => {
    return (
        <FPage style={{ background: "beige", border: "1px solid black", height: "100vh" }}>
            <FPageHeader style={{ background: "yellow", border: "1px solid black" }}>
                <FPageTitle style={{ background: "red", border: "1px solid black" }}>Form Title</FPageTitle>
                <ActionBar style={{ background: "red", border: "1px solid black" }} className="right">
                    <div>Cancel</div>
                    <div>Save</div>
                </ActionBar>
            </FPageHeader>
            <FPageContent style={{ background: "lightblue", border: "1px solid black", height: "100%" }}>
                <div>
                    <FormTabHtml>Basic parameters HTML</FormTabHtml>
                    <FormTabActiveHtml>Active Tab HTML</FormTabActiveHtml>
                </div>
                <div>
                    <FormTab defaultActiveKey="1" items={items} />
                </div>
            </FPageContent>
        </FPage>
    );
};
